const donationAmount = value => {
  const amount = Number(String(value ?? '').trim());
  return Number.isInteger(amount) && amount >= 1 && amount <= 1000 ? amount : null;
};

function donationError(form, message = '') {
  const error = form.querySelector('.donation-error, .giving-error');
  const input = form.querySelector('[name="donation_amount"]');
  if (error) {
    error.textContent = message;
    error.hidden = !message;
  }
  input?.setAttribute('aria-invalid', String(Boolean(message)));
}

function updateDonationForm(form, amount) {
  if (!form || !amount) return;
  const input = form.querySelector('[name="donation_amount"]');
  if (input) input.value = String(amount);
  donationError(form);
  form.querySelectorAll('[data-donation-preset], [data-gaza-preset]').forEach(button => {
    const selected = Number(button.dataset.donationPreset || button.dataset.gazaPreset) === amount;
    button.classList.toggle('selected', selected);
    button.setAttribute('aria-pressed', String(selected));
  });
  const modalLabel = form.querySelector('[data-donation-primary-label]');
  if (modalLabel) modalLabel.textContent = `Donate $${amount} & proceed to checkout`;
  const inlineCheckout = form.querySelector('.giving-direct-checkout-btn');
  if (inlineCheckout) inlineCheckout.textContent = `Donate $${amount} & checkout`;
}

function openDonationDialog(mode = 'standard') {
  const dialog = document.getElementById('donation-dialog');
  if (!dialog) return;
  const form = dialog.querySelector('[data-donation-form]');
  const heading = dialog.querySelector('#donation-heading');
  const addCart = dialog.querySelector('[data-donation-destination="cart"]');
  const skip = dialog.querySelector('[data-donation-skip]');
  dialog.dataset.mode = mode;
  if (heading) heading.textContent = mode === 'checkout' ? 'Before you go, would you like to give?' : 'Your gift. Their support.';
  if (addCart) addCart.hidden = mode === 'checkout';
  if (skip) skip.hidden = mode !== 'checkout';
  donationError(form);
  if (!dialog.open) dialog.showModal();
  dialog.querySelector('[name="donation_amount"]')?.focus();
}

function setVipPurchaseMode(enabled) {
  const card = document.getElementById('vip-subscription-card');
  const priceEl = document.querySelector('.detail-price');
  if (card) card.classList.toggle('is-selected', enabled);
  document.querySelectorAll('[data-purchase-mode]').forEach(button => {
    const selected = button.dataset.purchaseMode === (enabled ? 'vip' : 'standard');
    button.classList.toggle('is-selected', selected);
    button.setAttribute('aria-pressed', String(selected));
  });
  if (typeof updateBundleAndAddonTotals === 'function' && (document.getElementById('bundle-deals-section') || document.getElementById('product-addons-section'))) {
    updateBundleAndAddonTotals();
    return;
  }
  if (!priceEl) return;
  if (enabled) {
    const memberPrice = card?.dataset.memberPrice || '';
    const originalPrice = priceEl.dataset.originalPrice || priceEl.textContent.trim();
    priceEl.innerHTML = `<span class="member-price-val">${memberPrice}</span> <del class="regular-price-struck">${originalPrice}</del> <span class="vip-member-tag">VIP price today</span><small class="vip-recurring-price">+ $39.99/month membership</small>`;
    const stickyPrice = document.getElementById('mobile-sticky-price-display');
    if (stickyPrice) stickyPrice.innerHTML = `${memberPrice} <span class="sticky-vip-tag">VIP</span>`;
  } else {
    const originalPrice = priceEl.dataset.originalPrice || '';
    priceEl.innerHTML = `${originalPrice} <span class="currency-code">USD</span>`;
    const stickyPrice = document.getElementById('mobile-sticky-price-display');
    if (stickyPrice) stickyPrice.innerHTML = `${originalPrice}`;
  }
}

async function addDonation(form, destination, submitter) {
  const input = form.querySelector('[name="donation_amount"]');
  const amount = donationAmount(input?.value);
  if (!amount) {
    donationError(form, 'Enter a whole amount from $1 to $1,000.');
    input?.focus();
    return;
  }
  const host = form.closest('[data-variant-id]') || document.getElementById('donation-dialog');
  const variantId = Number(host?.dataset.variantId);
  if (!variantId) {
    donationError(form, 'Donations are being connected. Please try again shortly.');
    return;
  }
  const original = submitter?.innerHTML;
  if (submitter) {
    submitter.disabled = true;
    submitter.textContent = 'Adding your donation…';
  }
  donationError(form);
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items: [{id: variantId, quantity: amount, properties: {'_nooraya_gaza_donation': '100% to Gaza'}}]})
    });
    if (!response.ok) throw new Error('Cart request failed');
    window.location.assign(destination === 'checkout' ? (host.dataset.checkoutUrl || '/checkout') : (host.dataset.cartUrl || '/cart'));
  } catch (error) {
    donationError(form, 'We could not add the donation. Please try again.');
    if (submitter) {
      submitter.disabled = false;
      submitter.innerHTML = original;
    }
  }
}

document.addEventListener('click', event => {
  const button = event.target.closest('button, a');
  if (!button) return;
  if (button.hasAttribute('data-menu')) {
    const header = document.getElementById('header');
    const open = header.classList.toggle('menu-open');
    button.setAttribute('aria-expanded', String(open));
  }
  if (button.hasAttribute('data-search')) location.href = document.body.dataset.searchUrl;
  if (button.hasAttribute('data-close')) button.closest('dialog')?.close();
  if (button.hasAttribute('data-gallery-target')) {
    const gallery = button.closest('.product-gallery');
    const target = document.getElementById(button.dataset.galleryTarget);
    if (gallery && target) {
      gallery.querySelectorAll('[data-product-media]').forEach(media => {
        const video = media.querySelector('video');
        if (video) video.pause();
        media.hidden = media !== target;
      });
      const allThumbs = Array.from(gallery.querySelectorAll('[data-gallery-target]'));
      allThumbs.forEach(thumbnail => thumbnail.classList.remove('selected'));
      button.classList.add('selected');
      target.querySelector('video')?.play().catch(() => {});
      const badge = document.getElementById('gallery-counter-badge');
      if (badge && allThumbs.length > 0) {
        badge.textContent = `${allThumbs.indexOf(button) + 1} / ${allThumbs.length}`;
      }
    }
  } else if (button.hasAttribute('data-gallery')) {
    const image = document.getElementById('detail-image');
    image.src = button.dataset.gallery;
    image.removeAttribute('srcset');
  }
  if (button.matches('[data-donation-preset], [data-gaza-preset]')) {
    const form = button.closest('form');
    const amount = Number(button.dataset.donationPreset || button.dataset.gazaPreset);
    updateDonationForm(form, amount);
  }
  if (button.matches('[data-qty-btn]')) {
    const delta = parseInt(button.dataset.qtyBtn, 10);
    const input = document.getElementById('product-quantity');
    if (input) {
      const current = parseInt(input.value, 10) || 1;
      const next = Math.max(1, Math.min(99, current + delta));
      input.value = next;
    }
  }
});

document.querySelectorAll('[data-donate]').forEach(button => button.addEventListener('click', () => openDonationDialog('standard')));
document.querySelectorAll('[data-checkout-trigger]').forEach(button => button.addEventListener('click', event => {
  if (button.dataset.donationPresent === 'true') return;
  event.preventDefault();
  openDonationDialog('checkout');
}));
document.querySelectorAll('[data-donation-skip]').forEach(button => button.addEventListener('click', event => {
  event.preventDefault();
  const dialog = button.closest('#donation-dialog');
  window.location.assign(dialog?.dataset.checkoutUrl || '/checkout');
}));

document.addEventListener('input', event => {
  if (!event.target.matches('[name="donation_amount"]')) return;
  const form = event.target.closest('form');
  const amount = donationAmount(event.target.value);
  if (amount) updateDonationForm(form, amount);
  else donationError(form, 'Enter a whole amount from $1 to $1,000.');
});

document.addEventListener('submit', async event => {
  const form = event.target;
  if (form.matches('.product-purchase')) {
    event.preventDefault();
    const submitter = event.submitter;
    const isVip = submitter?.dataset.purchaseMode === 'vip';
    setVipPurchaseMode(isVip);

    const variantInput = form.querySelector('[name="id"]');
    const variantId = Number(variantInput?.value);
    if (!variantId) {
      let message = form.querySelector('.vip-purchase-error');
      if (!message) {
        message = document.createElement('p');
        message.className = 'vip-purchase-error';
        form.append(message);
      }
      message.textContent = 'Please choose a variant first.';
      return;
    }

    const qtyInput = form.querySelector('[name="quantity"]');
    const qty = Math.max(1, parseInt(qtyInput?.value, 10) || 1);

    const properties = {};
    if (isVip) {
      properties['VIP Subscription'] = '$39.99 / month';
    }

    const selectedBundleCard = document.querySelector('.bundle-deal-card.is-selected');
    if (selectedBundleCard && qty > 1) {
      const discount = selectedBundleCard.dataset.bundleDiscount;
      properties['Bundle Deal'] = `Buy ${qty} (Save extra ${discount}%)`;
    }

    const itemsToAdd = [{
      id: variantId,
      quantity: qty,
      properties: properties
    }];

    // Collect all checked companion add-ons
    const checkedAddons = Array.from(document.querySelectorAll('.addon-checkbox:checked'));
    checkedAddons.forEach(chk => {
      const addonId = Number(chk.dataset.addonId);
      if (addonId) {
        const addonProps = {
          'Add-on Deal': '1-Click Companion Bundle'
        };
        if (isVip) {
          addonProps['VIP Subscription'] = '$39.99 / month';
        }
        itemsToAdd.push({
          id: addonId,
          quantity: 1,
          properties: addonProps
        });
      }
    });

    const choiceButtons = form.querySelectorAll('.purchase-choice');
    choiceButtons.forEach(b => {
      if (!b.dataset.defaultHtml) b.dataset.defaultHtml = b.innerHTML;
      b.disabled = true;
    });
    const originalHtml = submitter ? submitter.innerHTML : '';
    if (submitter) {
      if (!submitter.dataset.defaultHtml) submitter.dataset.defaultHtml = originalHtml;
      const isSocial = document.documentElement.classList.contains('is-social-visitor');
      const totalCount = qty + checkedAddons.length;
      submitter.innerHTML = isSocial
        ? `<span class="purchase-choice-label">Adding ${totalCount > 1 ? totalCount + ' items ' : ''}to Cart…</span>`
        : `<span class="purchase-choice-label">Adding ${totalCount > 1 ? totalCount + ' items ' : ''}to Cart…</span><small>${isVip ? 'VIP member price today' : '20% Sale Price'}</small>`;
    }

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: itemsToAdd
        })
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.description || 'Could not add to cart.');
      }

      try {
        const cartRes = await fetch(`${root}cart.js`);
        if (cartRes.ok) {
          const cartData = await cartRes.json();
          document.querySelectorAll('#cart-count').forEach(el => {
            el.textContent = cartData.item_count;
            el.hidden = cartData.item_count === 0;
          });
        }
      } catch {}

      if (submitter) {
        const isSocial = document.documentElement.classList.contains('is-social-visitor');
        submitter.innerHTML = isSocial
          ? `<span class="purchase-choice-label">✓ Added to Cart!</span>`
          : `<span class="purchase-choice-label">✓ Added to Cart!</span><small>Opening your cart…</small>`;
      }

      window.location.assign(`${root}cart`);
    } catch (error) {
      choiceButtons.forEach(b => { b.disabled = false; });
      if (submitter) submitter.innerHTML = originalHtml;
      let message = form.querySelector('.vip-purchase-error');
      if (!message) {
        message = document.createElement('p');
        message.className = 'vip-purchase-error';
        form.append(message);
      }
      message.textContent = error.message || 'We could not add this item to your cart. Please try again.';
    }
    return;
  }
  if (!form.matches('[data-donation-form], [data-inline-donation-form]')) return;
  event.preventDefault();
  const submitter = event.submitter;
  addDonation(form, submitter?.dataset.donationDestination || 'cart', submitter);
});

document.addEventListener('change',event=>{
  if(event.target.id==='vip-order-bump-checkbox'){
    setVipPurchaseMode(event.target.checked);
  }
  if(event.target.matches('[data-variant-picker]')){
    const url=new URL(location.href);
    url.searchParams.set('variant',event.target.value);
    history.replaceState(null, '', url.href);
  }
});
setVipPurchaseMode(false);
document.addEventListener('keydown',event=>{
  if(event.key==='Escape'){
    const header=document.getElementById('header');
    header?.classList.remove('menu-open');
    document.querySelector('[data-menu]')?.setAttribute('aria-expanded','false');
  }
});
document.getElementById('donation-dialog')?.addEventListener('click',event=>{
  if(event.target===event.currentTarget){
    const box=event.currentTarget.getBoundingClientRect();
    if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)event.currentTarget.close();
  }
});
const scrollToHash=()=>{if(location.hash)document.querySelector(location.hash)?.scrollIntoView({block:'start'});};
addEventListener('load',scrollToHash);
addEventListener('hashchange',scrollToHash);
const VISITOR_PROFILE_KEY='nooraya_visitor_profile_v1';
const ONE_HOUR_MS=60*60*1000;
function checkVipVisibility(){
  const card=document.getElementById('vip-subscription-card');
  const vipChoiceBtn = document.querySelector('button[data-purchase-mode="vip"]');
  const standardChoiceBtn = document.querySelector('button[data-purchase-mode="standard"]');
  const bumpCheckbox = document.getElementById('vip-order-bump-checkbox');

  const params=new URLSearchParams(window.location.search);
  const ref=(document.referrer||'').toLowerCase();
  const ua=(navigator.userAgent||'').toLowerCase();
  const utmSource=(params.get('utm_source')||'').toLowerCase();
  const utmMedium=(params.get('utm_medium')||'').toLowerCase();
  const paramRef=(params.get('ref')||'').toLowerCase();
  const modeParam=(params.get('mode')||'').toLowerCase();

  // Explicit override params for testing:
  const forceVip = params.get('vip') === '1' || params.get('preview_vip') === 'true' || paramRef === 'google' || utmSource === 'google' || ref.includes('google.');
  const forceSocial = params.get('organic') === '1' || paramRef === 'tiktok' || paramRef === 'instagram' || paramRef === 'facebook' || modeParam === 'social' || params.get('hide_vip') === '1';

  // Social in-app browsers (TikTok, Instagram, Facebook, Threads, Twitter, Snapchat):
  const isSocialUA = 
    ua.includes('tiktok') ||
    ua.includes('musical_ly') ||
    ua.includes('bytedance') ||
    ua.includes('trill') ||
    ua.includes('aweme') ||
    ua.includes('instagram') ||
    ua.includes('fban') ||
    ua.includes('fbav') ||
    ua.includes('fb_iab') ||
    ua.includes('fb4a') ||
    ua.includes('fbios') ||
    ua.includes('barcelona') ||
    ua.includes('snapchat') ||
    ua.includes('twitter');

  // Social referrers (including Android app intents from TikTok/IG/FB):
  const isSocialReferrer = 
    ref.includes('tiktok.com') ||
    ref.includes('instagram.com') ||
    ref.includes('facebook.com') ||
    ref.includes('fb.com') ||
    ref.includes('threads.net') ||
    ref.includes('t.co') ||
    ref.includes('twitter.com') ||
    ref.includes('x.com') ||
    ref.includes('snapchat.com') ||
    ref.includes('youtube.com') ||
    ref.includes('com.zhiliaoapp.musically') ||
    ref.includes('com.instagram.android') ||
    ref.includes('com.facebook.katana') ||
    ref.includes('com.facebook.orca');

  const isSocialParams = 
    ['tiktok', 'instagram', 'facebook', 'ig', 'fb', 'threads', 'yt', 'twitter', 'snapchat'].includes(utmSource) ||
    ['bio', 'tiktok', 'ig', 'instagram', 'facebook', 'linktree', 'snapchat'].includes(paramRef) ||
    Boolean(params.get('ttclid')) ||
    Boolean(params.get('fbclid')) ||
    utmMedium === 'social' ||
    utmMedium === 'organic_social';

  let sessionMode = null;
  try { sessionMode = sessionStorage.getItem('nooraya_traffic_mode'); } catch {}

  let isSocial = false;
  if (forceSocial || isSocialUA || isSocialReferrer || isSocialParams) {
    isSocial = true;
  } else if (forceVip) {
    isSocial = false;
  } else if (sessionMode === 'social') {
    isSocial = true;
  } else if (sessionMode === 'organic') {
    isSocial = false;
  } else {
    // Direct browser entry or standard navigation
    isSocial = false;
  }

  try {
    sessionStorage.setItem('nooraya_traffic_mode', isSocial ? 'social' : 'organic');
  } catch {}

  if (isSocial) {
    document.documentElement.classList.add('is-social-visitor');
    document.body?.classList.add('is-social-visitor');
    if (card) card.style.display = 'none';
    if (vipChoiceBtn) {
      vipChoiceBtn.style.display = 'none';
      vipChoiceBtn.classList.remove('is-selected');
      vipChoiceBtn.setAttribute('aria-pressed', 'false');
    }
    if (standardChoiceBtn) {
      standardChoiceBtn.classList.add('is-selected');
      standardChoiceBtn.setAttribute('aria-pressed', 'true');
    }
    if (bumpCheckbox) bumpCheckbox.checked = false;
    setVipPurchaseMode(false);
  } else {
    document.documentElement.classList.remove('is-social-visitor');
    document.body?.classList.remove('is-social-visitor');
    if (card) card.style.display = '';
    if (vipChoiceBtn) vipChoiceBtn.style.display = '';
  }
}
checkVipVisibility();
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',checkVipVisibility);}
if(new URLSearchParams(window.location.search).get('donation_preview')==='checkout'){
  openDonationDialog('checkout');
}

/* ==========================================================================
   CUSTOMER REVIEWS (Verona Books Style for Nooraya)
   ========================================================================== */

function initReviewScroll() {
  document.addEventListener('click', (e) => {
    const scrollTrigger = e.target.closest('[data-scroll-to-reviews]');
    if (scrollTrigger) {
      e.preventDefault();
      const reviewsEl = document.getElementById('customer-reviews');
      if (reviewsEl) {
        reviewsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
}

function initReviewLightbox() {
  const lbOverlay = document.getElementById('vcr-lb-overlay');
  if (!lbOverlay) return;
  const lbImg = lbOverlay.querySelector('img');
  const lbClose = lbOverlay.querySelector('.vcr-lb-x');

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.vcr-pgrid img, .vcr-rphotos img');
    if (trigger) {
      const fullUrl = trigger.getAttribute('data-full') || trigger.src;
      if (lbImg) lbImg.src = fullUrl;
      lbOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  });

  const closeLb = () => {
    lbOverlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  if (lbClose) lbClose.addEventListener('click', closeLb);
  lbOverlay.addEventListener('click', (e) => {
    if (e.target === lbOverlay) closeLb();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && lbOverlay.classList.contains('active')) closeLb();
  });
}

function initWriteReviewModal() {
  const modal = document.getElementById('vcr-write-modal');
  if (!modal) return;

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-write-review-btn]')) {
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
    }
    if (e.target.closest('[data-close-review-modal]')) {
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
    }
  });

  let selectedStar = 5;
  const starBtns = modal.querySelectorAll('.star-btn');
  starBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      selectedStar = parseInt(btn.getAttribute('data-star') || '5', 10);
      starBtns.forEach(b => {
        const val = parseInt(b.getAttribute('data-star') || '0', 10);
        if (val <= selectedStar) {
          b.classList.add('active');
        } else {
          b.classList.remove('active');
        }
      });
    });
  });

  const reviewForm = document.getElementById('vcr-review-form');
  const reviewStatus = document.getElementById('vcr-status');
  if (reviewForm) {
    reviewForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const orderId = document.getElementById('rev-order')?.value?.trim();
      const name = document.getElementById('rev-name')?.value?.trim() || 'Verified Customer';
      if (!orderId || orderId.length < 4) {
        if (reviewStatus) {
          reviewStatus.textContent = '⚠️ Please enter a valid Nooraya Order ID (e.g. #NO-104829) to verify your purchase.';
          reviewStatus.style.background = '#FEF2F2';
          reviewStatus.style.color = '#991B1B';
          reviewStatus.style.borderColor = '#F87171';
          reviewStatus.hidden = false;
        }
        return;
      }
      if (reviewStatus) {
        reviewStatus.textContent = '✨ Shukran, ' + name + '! Your verified review for order ' + orderId + ' has been submitted and will appear shortly.';
        reviewStatus.style.background = '#ECFDF5';
        reviewStatus.style.color = '#065F46';
        reviewStatus.style.borderColor = '#A7F3D0';
        reviewStatus.hidden = false;
      }
      const submitBtn = reviewForm.querySelector('.vcr-submit-btn');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Review Submitted ✓';
      }
      setTimeout(() => {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      }, 2600);
    });
  }
}

function initLoadMoreReviews() {
  const loadMoreBtn = document.getElementById('vcr-lm');
  const caption = document.getElementById('vcr-cap');
  const reviewList = document.getElementById('vcr-list');
  if (!loadMoreBtn || !reviewList) return;

  const allReviews = Array.from(reviewList.querySelectorAll('.vcr-rev'));
  const totalCount = allReviews.length;
  if (totalCount <= 5) {
    if (loadMoreBtn) loadMoreBtn.style.display = 'none';
    return;
  }

  let visibleCount = 5;
  allReviews.forEach((rev, idx) => {
    if (idx >= visibleCount) {
      rev.setAttribute('hidden', '');
    } else {
      rev.removeAttribute('hidden');
    }
  });

  const totalReviewsCount = caption ? (caption.textContent.match(/of\s+([0-9,]+)/i)?.[1] || totalCount) : totalCount;
  if (caption) {
    caption.textContent = `Showing ${visibleCount} of ${totalReviewsCount} reviews`;
  }

  // Clone button to ensure clean event listener binding
  const newBtn = loadMoreBtn.cloneNode(true);
  loadMoreBtn.parentNode.replaceChild(newBtn, loadMoreBtn);

  newBtn.addEventListener('click', () => {
    visibleCount += 5;
    allReviews.forEach((rev, idx) => {
      if (idx < visibleCount) {
        rev.removeAttribute('hidden');
      }
    });

    const shown = Math.min(visibleCount, totalCount);
    if (caption) {
      caption.textContent = `Showing ${shown} of ${totalReviewsCount} reviews`;
    }

    if (shown >= totalCount) {
      newBtn.textContent = 'All verified reviews loaded ✓';
      newBtn.disabled = true;
      newBtn.style.opacity = '0.6';
      newBtn.style.cursor = 'default';
    }
  });
}

function initMobileGallerySwipe() {
  const stage = document.querySelector('[data-product-gallery-stage]');
  if (!stage) return;
  let startX = 0;
  let startY = 0;
  stage.addEventListener('touchstart', (e) => {
    if (e.touches.length === 1) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }
  }, { passive: true });

  stage.addEventListener('touchend', (e) => {
    if (!startX || !startY) return;
    const diffX = e.changedTouches[0].clientX - startX;
    const diffY = e.changedTouches[0].clientY - startY;
    if (Math.abs(diffX) > 40 && Math.abs(diffX) > Math.abs(diffY)) {
      const allThumbs = Array.from(document.querySelectorAll('.thumbnails [data-gallery-target]'));
      if (allThumbs.length < 2) return;
      const currentIdx = allThumbs.findIndex(t => t.classList.contains('selected'));
      let nextIdx = currentIdx;
      if (diffX < 0) {
        nextIdx = (currentIdx + 1) % allThumbs.length;
      } else {
        nextIdx = (currentIdx - 1 + allThumbs.length) % allThumbs.length;
      }
      allThumbs[nextIdx]?.click();
      allThumbs[nextIdx]?.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    }
    startX = 0;
    startY = 0;
  }, { passive: true });
}

function initStickyMobileBar() {
  const stickyBar = document.getElementById('mobile-sticky-bar');
  const triggerBtn = document.getElementById('mobile-sticky-trigger');
  const purchaseForm = document.querySelector('.product-purchase');
  if (!stickyBar || !purchaseForm) return;

  const handleScroll = () => {
    if (window.innerWidth > 768) {
      stickyBar.hidden = true;
      stickyBar.classList.remove('is-visible');
      return;
    }
    const rect = purchaseForm.getBoundingClientRect();
    if (rect.bottom < 60) {
      stickyBar.hidden = false;
      requestAnimationFrame(() => stickyBar.classList.add('is-visible'));
    } else {
      stickyBar.classList.remove('is-visible');
      setTimeout(() => {
        if (!stickyBar.classList.contains('is-visible')) stickyBar.hidden = true;
      }, 250);
    }
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', handleScroll, { passive: true });

  triggerBtn?.addEventListener('click', () => {
    const isVipActive = document.querySelector('button[data-purchase-mode="vip"]')?.classList.contains('is-selected');
    const activeBtn = isVipActive 
      ? document.querySelector('button[data-purchase-mode="vip"]') 
      : document.querySelector('button[data-purchase-mode="standard"]');
    if (activeBtn) {
      activeBtn.click();
    } else {
      purchaseForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
}

function initDailySaleTimer() {
  function getTargetTime() {
    const now = new Date();
    const target = new Date(now);
    target.setHours(21, 0, 0, 0); // 21:00 (9:00 PM) daily
    if (now.getTime() >= target.getTime()) {
      target.setDate(target.getDate() + 1);
    }
    return target.getTime();
  }

  function update() {
    const now = Date.now();
    const target = getTargetTime();
    const diff = Math.max(0, target - now);

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    const pad = (n) => String(n).padStart(2, '0');
    const timerText = `${pad(hours)}h : ${pad(minutes)}m : ${pad(seconds)}s`;

    document.querySelectorAll('[data-sale-timer]').forEach(el => {
      el.textContent = timerText;
    });
  }

  update();
  setInterval(update, 1000);
}

function updateBundleAndAddonTotals() {
  const form = document.querySelector('.product-purchase');
  if (!form) return;

  const selectedCard = document.querySelector('.bundle-deal-card.is-selected') || document.querySelector('.bundle-deal-card');
  const bundleQty = parseInt(selectedCard?.dataset.bundleQty || '1', 10);
  const bundleTotal = parseInt(selectedCard?.dataset.totalPrice || '0', 10);
  const bundleUnit = parseInt(selectedCard?.dataset.unitPrice || '0', 10);

  // Sync hidden quantity input
  const qtyInput = form.querySelector('[name="quantity"]');
  if (qtyInput) qtyInput.value = bundleQty;

  // Add-ons total
  const checkedAddons = Array.from(document.querySelectorAll('.addon-checkbox:checked'));
  let addonsStandardTotal = 0;
  let addonsVipTotal = 0;
  checkedAddons.forEach(chk => {
    addonsStandardTotal += parseInt(chk.dataset.addonPrice || '0', 10);
    addonsVipTotal += parseInt(chk.dataset.addonVipPrice || '0', 10);
  });

  const bundleVipTotal = Math.round(bundleTotal / 2);
  const grandStandardTotal = bundleTotal + addonsStandardTotal;
  const grandVipTotal = bundleVipTotal + addonsVipTotal;

  const formatCents = (c) => `$${(Math.round(c || 0) / 100).toFixed(2)}`;

  const isSocial = document.documentElement.classList.contains('is-social-visitor');
  const addonCount = checkedAddons.length;
  const addonSuffix = addonCount > 0 ? ` (+${addonCount} Add-on${addonCount > 1 ? 's' : ''})` : '';

  // Update Standard Button
  const standardBtn = form.querySelector('button[data-purchase-mode="standard"]');
  if (standardBtn) {
    if (isSocial) {
      standardBtn.innerHTML = `<span class="purchase-choice-label">Add to Cart · ${formatCents(grandStandardTotal)}</span>`;
    } else {
      standardBtn.innerHTML = `
        <span class="purchase-choice-label">Add to Cart</span>
        <strong>${formatCents(grandStandardTotal)}</strong>
        <small>${bundleQty > 1 ? `Bundle of ${bundleQty} · ` : ''}20% Barakah Discount${addonSuffix}</small>
      `;
    }
    standardBtn.dataset.defaultHtml = standardBtn.innerHTML;
  }

  // Update VIP Button
  const vipBtn = form.querySelector('button[data-purchase-mode="vip"]');
  if (vipBtn) {
    vipBtn.innerHTML = `
      <span class="purchase-choice-label">Add to Cart with VIP</span>
      <strong>${formatCents(grandVipTotal)} today</strong>
      <small>Save 50% extra · + $39.99/mo${addonSuffix}</small>
    `;
    vipBtn.dataset.defaultHtml = vipBtn.innerHTML;
  }

  // Determine if VIP mode is visually active
  const isVipActive = vipBtn?.classList.contains('is-selected');

  // Sync VIP showcase card member price callout
  const vipDealVal = document.querySelector('.vip-deal-price-val');
  if (vipDealVal && bundleVipTotal > 0) {
    vipDealVal.textContent = formatCents(bundleVipTotal);
  }

  // Update Main Product Price Display
  const priceEl = document.querySelector('.detail-price');
  if (priceEl && bundleTotal > 0) {
    if (isVipActive) {
      priceEl.innerHTML = `<span class="member-price-val">${formatCents(bundleVipTotal)}</span> <del class="regular-price-struck">${formatCents(bundleTotal)}</del> <span class="vip-member-tag">VIP price today</span><small class="vip-recurring-price">+ $39.99/month membership</small>`;
    } else {
      priceEl.innerHTML = `${formatCents(bundleTotal)} <span class="currency-code">USD</span>`;
    }
  }

  // Update Mobile Sticky Bar Price
  const stickyPrice = document.getElementById('mobile-sticky-price-display');
  if (stickyPrice) {
    if (isVipActive) {
      stickyPrice.innerHTML = `${formatCents(grandVipTotal)} <span class="sticky-vip-tag">VIP</span>`;
    } else {
      stickyPrice.innerHTML = `${formatCents(grandStandardTotal)}`;
    }
  }
}

function initBundleAndAddonEngine() {
  const bundleSection = document.getElementById('bundle-deals-section');
  const addonsSection = document.getElementById('product-addons-section');

  if (bundleSection) {
    bundleSection.addEventListener('click', (e) => {
      const card = e.target.closest('.bundle-deal-card');
      if (!card) return;
      bundleSection.querySelectorAll('.bundle-deal-card').forEach(c => {
        c.classList.remove('is-selected');
        c.setAttribute('aria-checked', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-checked', 'true');
      updateBundleAndAddonTotals();
    });

    bundleSection.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Enter') {
        const card = e.target.closest('.bundle-deal-card');
        if (card) {
          e.preventDefault();
          card.click();
        }
      }
    });
  }

  if (addonsSection) {
    addonsSection.addEventListener('change', (e) => {
      if (e.target.matches('.addon-checkbox')) {
        const row = e.target.closest('.addon-item-row');
        if (row) {
          row.classList.toggle('is-active', e.target.checked);
        }
        updateBundleAndAddonTotals();
      }
    });
  }

  // Sync initial row classes
  document.querySelectorAll('.addon-checkbox').forEach(chk => {
    chk.closest('.addon-item-row')?.classList.toggle('is-active', chk.checked);
  });

  if (bundleSection || addonsSection) {
    updateBundleAndAddonTotals();
  }
}

function initBackButtonReset() {
  const storeDefaults = () => {
    document.querySelectorAll('.purchase-choice').forEach(btn => {
      if (!btn.dataset.defaultHtml) {
        btn.dataset.defaultHtml = btn.innerHTML;
      }
    });
  };

  const resetButtons = () => {
    document.querySelectorAll('.purchase-choice').forEach(btn => {
      btn.disabled = false;
      if (btn.dataset.defaultHtml) {
        btn.innerHTML = btn.dataset.defaultHtml;
      }
    });
    const stickyBtn = document.getElementById('mobile-sticky-trigger');
    if (stickyBtn) {
      stickyBtn.disabled = false;
      stickyBtn.innerHTML = '<span>Add to Cart</span>';
    }
    document.querySelectorAll('.vip-purchase-error').forEach(el => el.remove());
    if (typeof updateBundleAndAddonTotals === 'function') {
      updateBundleAndAddonTotals();
    }
  };

  storeDefaults();

  window.addEventListener('pageshow', (event) => {
    resetButtons();
  });

  window.addEventListener('popstate', () => {
    resetButtons();
  });
}

function initVariantOptionSelectors() {
  const container = document.getElementById('variant-options-container');
  if (!container) return;

  const select = container.querySelector('[data-variant-picker]');
  if (!select) return;

  const selectedOptions = {};
  container.querySelectorAll('.variant-option-group').forEach(group => {
    const activeBtn = group.querySelector('.is-active');
    const optIndex = group.dataset.optionIndex;
    if (activeBtn) {
      selectedOptions[optIndex] = activeBtn.dataset.optionValue;
    }
  });

  function updateMatchingVariant() {
    let matchedOption = null;
    Array.from(select.options).forEach(opt => {
      let isMatch = true;
      if (selectedOptions[0] && opt.dataset.option1 !== selectedOptions[0]) isMatch = false;
      if (selectedOptions[1] && opt.dataset.option2 !== selectedOptions[1]) isMatch = false;
      if (selectedOptions[2] && opt.dataset.option3 !== selectedOptions[2]) isMatch = false;
      if (isMatch) matchedOption = opt;
    });

    if (matchedOption) {
      select.value = matchedOption.value;
      const url = new URL(location.href);
      url.searchParams.set('variant', matchedOption.value);
      history.replaceState(null, '', url.href);

      // If matchedOption has media ID, switch gallery
      const mediaId = matchedOption.dataset.mediaId;
      if (mediaId) {
        const mediaEl = document.querySelector(`[data-product-media="${mediaId}"]`);
        if (mediaEl) {
          document.querySelectorAll('.product-gallery-media').forEach(m => m.hidden = true);
          mediaEl.hidden = false;
        }
      }

      if (typeof updateBundleAndAddonTotals === 'function') {
        updateBundleAndAddonTotals();
      }
    }
  }

  container.addEventListener('click', (e) => {
    const btn = e.target.closest('.variant-swatch-btn, .variant-size-btn');
    if (!btn) return;

    const group = btn.closest('.variant-option-group');
    if (!group) return;

    const optIndex = group.dataset.optionIndex;
    const optValue = btn.dataset.optionValue;

    // Toggle active state in group
    group.querySelectorAll('.variant-swatch-btn, .variant-size-btn').forEach(b => {
      b.classList.remove('is-active');
      b.setAttribute('aria-checked', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-checked', 'true');

    // Update label display
    const labelDisplay = group.querySelector('.variant-selected-val');
    if (labelDisplay) labelDisplay.textContent = optValue;

    selectedOptions[optIndex] = optValue;
    updateMatchingVariant();
  });
}

function initCustomerReviews() {
  initReviewScroll();
  initReviewLightbox();
  initWriteReviewModal();
  initLoadMoreReviews();
  initMobileGallerySwipe();
  initStickyMobileBar();
  initDailySaleTimer();
  initBundleAndAddonEngine();
  initVariantOptionSelectors();
  initBackButtonReset();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomerReviews);
} else {
  initCustomerReviews();
}
